/**
 * 邮箱
 */
export function isEmail(s) {
  return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s)
}

/**
 * 手机号
 */
export function isMobile(s) {
  return /^1[0-9]{10}$/.test(s)
}

/**
 * 电话号码
 */
export function isPhone(s) {
  return /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(s)
}

/**
 * URL
 */
export function isURL(s) {
  return /^http[s]?:\/\/.*/.test(s)
}

/**
 * 补零
 */
function padZero(num) {
  return num.toString().padStart(2, '0')
}

/**
 * 格式化日期时间（秒）
 */
export function fomDate(s) {
  const date = new Date(s)
  const year = date.getFullYear()
  const month = padZero(date.getMonth() + 1)
  const day = padZero(date.getDate())
  const hh = padZero(date.getHours())
  const mm = padZero(date.getMinutes())
  const ss = padZero(date.getSeconds())

  return `${year}-${month}-${day} ${hh}:${mm}:${ss}`
}

/**
 * 格式化日期时间（分）
 */
export function fomDateTime(s) {
  const date = new Date(s)
  const year = date.getFullYear()
  const month = padZero(date.getMonth() + 1)
  const day = padZero(date.getDate())
  const hh = padZero(date.getHours())
  const mm = padZero(date.getMinutes())

  return `${year}-${month}-${day} ${hh}:${mm}`
}

export function fomDateTime2(s) {
  const date = new Date(s)
  const year = date.getFullYear()
  const month = padZero(date.getMonth() + 1)
  const day = padZero(date.getDate())
  const hh = padZero(date.getHours())
  const mm = padZero(date.getMinutes())
  const ss = padZero(date.getSeconds())

  return `${year}-${month}-${day} ${hh}:${mm}:${ss}`
}

/**
 * 仅日期
 */
export function dateFormat(s) {
  if (!s) return ''
  const date = new Date(s)
  return `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())}`
}

/**
 * 年月
 */
export function dateYearsFormat(s) {
  if (!s) return ''
  const date = new Date(s)
  return `${date.getFullYear()}-${padZero(date.getMonth() + 1)}`
}

/**
 * 小时:分钟
 */
export function dateHourFormat(s) {
  if (!s) return ''
  const date = new Date(s)
  return `${date.getHours()}:${date.getMinutes()}`
}

/**
 * 日期加天数
 */
export function addDate(date, days = 0) {
  const d = new Date(date)
  d.setDate(d.getDate() + days)
  return `${d.getFullYear()}-${padZero(d.getMonth() + 1)}-${padZero(d.getDate())}`
}

/**
 * 数字（两位小数）
 */
export function isNumber(s) {
  return /^(0(\.\d{1,2})?|[1-9]\d*(\.\d{1,2})?)$/.test(s)
}

/**
 * 数字（四位小数）
 */
export function isNumber4(s) {
  return /^(0|([1-9]\d*))(\.\d{1,4})?$/.test(s)
}

export function isNumberStr(s) {
  return /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g.test(s)
}

/**
 * 负数（两位小数）
 */
export function isNegativeNumber(s) {
  return /^-?(0(\.\d{1,2})?|[1-9]\d*(\.\d{1,2})?)$/.test(s)
}

/**
 * 正整数
 */
export function isInt(s) {
  return /^([0]|[1-9][0-9]*)$/.test(s)
}

/**
 * 负整数
 */
export function isNegativeInt(s) {
  return /^-([0]|[1-9][0-9]*)$/.test(s)
}

/**
 * checkbox 转字符串
 */
export function isCheckbox(s) {
  return s ? '1' : '0'
}

/**
 * UTF-8 字节
 */
export function strUtf8Bytes(str) {
  const utf8 = []

  for (let i = 0; i < str.length; i++) {
    let charCode = str.charCodeAt(i)

    if (charCode < 0x80) {
      utf8.push(charCode)
    } else if (charCode < 0x800) {
      utf8.push(
        0xc0 | (charCode >> 6),
        0x80 | (charCode & 0x3f)
      )
    } else if (charCode < 0xd800 || charCode >= 0xe000) {
      utf8.push(
        0xe0 | (charCode >> 12),
        0x80 | ((charCode >> 6) & 0x3f),
        0x80 | (charCode & 0x3f)
      )
    } else {
      i++
      charCode =
        0x10000 +
        (((charCode & 0x3ff) << 10) | (str.charCodeAt(i) & 0x3ff))
      utf8.push(
        0xf0 | (charCode >> 18),
        0x80 | ((charCode >> 12) & 0x3f),
        0x80 | ((charCode >> 6) & 0x3f),
        0x80 | (charCode & 0x3f)
      )
    }
  }

  return utf8.map(code => (code > 127 ? code - 256 : code))
}

/**
 * 转 16 进制
 */
export function convertStr16(s) {
  if (!s) return ''
  const chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F']
  const result = []

  for (const byte of s) {
    result.push(chars[(byte & 0xf0) >> 4])
    result.push(chars[byte & 0x0f])
  }

  return result.join('')
}

/**
 * 判断是否为合法的数字 ID
 * 支持：
 * - number（正整数）
 * - string（纯数字）
 */
export function isValidId(id) {
  if (typeof id === 'number') {
    return Number.isInteger(id) && id > 0;
  }
  if (typeof id === 'string') {
    return id.length > 0 && /^\d+$/.test(id);
  }
  return false;
}
